import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Text, Tooltip } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { appActions } from 'app/app.actions';
import { AppLink } from 'components/appLink';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
const defaultActions = {
    link: true,
};
/**
 * Represents the component for displaying the conversation id and various quick
 * actions associated with that conversation.
 */
export const ConversationId = (props) => {
    const dispatch = useAppDispatch();
    const { csid } = props;
    const actions = Object.assign({}, defaultActions, props.actions);
    /**
     * Represents the csid element including whether or the element should be a
     * link or not based on the actions configuration.
     */
    const csidElement = useMemo(() => {
        var _a;
        const text = `#${csid}`;
        const handleClick = () => {
            var _a, _b;
            if (actions.link && typeof actions.link !== 'boolean') {
                (_b = (_a = actions.link).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        return typeof actions.link === 'undefined' ? (_jsx(Text.Paragraph, { children: text })) : (_jsx(AppLink, Object.assign({ path: "/conversation/:csid", params: { path: { csid: csid.toString() } }, onClick: handleClick, target: typeof actions.link !== 'boolean' && ((_a = actions.link) === null || _a === void 0 ? void 0 : _a.openInNewTab)
                ? '_blank'
                : '_self', "data-testid": "conversation-id-link" }, { children: _jsx(Text.ExternalLink, Object.assign({ as: "span" }, { children: text })) })));
    }, [csid, actions.link]);
    /** Represents the preview element. */
    const previewElement = useMemo(() => {
        if (!actions.preview) {
            return null;
        }
        const handlePreview = () => {
            var _a, _b;
            dispatch(appActions.showModal({
                modal: { type: 'app:conversationPreview', arg: { csid } },
            }));
            if (actions.preview && typeof actions.preview !== 'boolean') {
                (_b = (_a = actions.preview).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        return (_jsx(Tooltip, Object.assign({ content: "Preview conversation", dark: true }, { children: _jsx(IconButton, { icon: "eye", variant: "tertiary", onClick: handlePreview }) })));
    }, [actions.preview, csid, dispatch]);
    return (_jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center", style: { display: 'inline-flex' } }, { children: [csidElement, previewElement] })));
};
